
import FastImage from "../../../../globals/elements/fastimg"
export default function Service5({ options, data }) 
{
    return (
        <div className="section-full  bg-gray p-t80 p-b50">
        <div className="container">
            {/* TITLE START*/}
            <div className="section-head text-center">
                <h2 data-title="Explore">{options?.title}</h2>
                <div className="mt-separator-outer">
                    <div className="mt-separator site-bg-primary" />
                </div>
            </div>
            {/* TITLE END*/}
            <div className="section-content">
                <div className="row d-flex justify-content-center">

                    {
                        data && data.length > 0 && data.map((item, index) => {
                            return <div key={index} className="col-lg-4 col-md-6">
                                <div className="mt-icon-box-wraper m-b30  p-a30 center bg-white">
                                    <div className="mt-icon-box-sm site-bg-primary m-b20 radius-10">
                                        <span className="icon-cell text-white">
                                            <FastImage src={item?.img?.url} color="#fff"/>
                                        </span>
                                    </div>
                                    <div className="icon-content">
                                        <h4 className="mt-tilte">{item?.title}</h4>
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            </div>
                        })
                    }

                </div>
            </div>
        </div>
    </div>
    )
}